import { Suspense, lazy, ElementType } from 'react';
// components
import { LoadingScreen } from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
(
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')));
export const LogoutPage = Loadable(lazy(() => import('../pages/auth/logout-page')));
export const SignUpPage = Loadable(lazy(() => import('../pages/auth/SignUpPage')));
export const LoginWithOtp = Loadable(lazy(() => import('../pages/auth/LoginWithOtp')));
export const ForgotPasswordPage = Loadable(lazy(() => import('../pages/auth/ForgotPassword')));
export const AddNewPassword = Loadable(lazy(() => import('../pages/auth/AddNewPassword')));
export const HomePage = Loadable(lazy(() => import('../pages/home/HomePage')));
export const LandingPage = Loadable(lazy(() => import('../pages/landing/Homes')));
export const SmsCodeVerification = Loadable(lazy(() => import('../pages/auth/SmsCodeVerification')));
export const Dashboard = Loadable(lazy(() => import('../pages/dashboard/Dashboard')));
export const Notification = Loadable(lazy(() => import('../pages/notification/Notification')));
export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
export const PageTwo = Loadable(lazy(() => import('../pages/PageTwo')));
export const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
export const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
export const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));
export const Scan = Loadable(lazy(() => import('../pages/Scan/Scan')));
export const Page403 = Loadable(lazy(() => import('../pages/error_pages/Page403')));
export const Page404 = Loadable(lazy(() => import('../pages/error_pages/Page404')));
export const Page500 = Loadable(lazy(() => import('../pages/error_pages/Page500')));
export const Settings = Loadable(lazy(() => import('../pages/Settings')));

export const Upload = Loadable(lazy(() => import('../pages/upload/Uploads')));
export const Product = Loadable(lazy(() => import('../pages/product/Product')));
export const ProductDetail = Loadable(lazy(() => import('../pages/product/ProductDetail')));
export const Book = Loadable(lazy(() => import('../pages/books/Book')));
export const BookDetail = Loadable(lazy(() => import('../pages/books/BookDetail')));
export const BookCreatePage = Loadable(lazy(() => import('../pages/books/BookCreatePage')));
export const BookEditPage = Loadable(lazy(() => import('../pages/books/BookEditPage')));
export const AccountSettings = Loadable(lazy(() => import('../pages/user/settings/AccountSettings')));
export const UserList = Loadable(lazy(() => import('../pages/user/list/Listing')));
export const NewUser = Loadable(lazy(() => import('../pages/user/new/UserCreatePage')));
export const UserDetail = Loadable(lazy(() => import('../pages/user/detail/UserDetail')));
export const UserEditPage = Loadable(lazy(() => import('../pages/user/detail/UserEditPage')));
export const OrganizationList = Loadable(lazy(() => import('../pages/organization/list/OrganizationListing')));
export const NewOrganization = Loadable(lazy(() => import('../pages/organization/new/OrganizationCreatePage')));
export const OrganizationDetailPage = Loadable(lazy(() => import('../pages/organization/detail/OrganizationDetailsPage')));
export const OrganizationEditPage = Loadable(lazy(() => import('../pages/organization/detail/OrganizationEditPage')));
export const EmailVerification = Loadable(lazy(() => import('../pages/EmailVerification')));

export const PaymentMethods = Loadable(lazy(() => import('../pages/billing/PaymentMethods')));
export const InvoiceListPage = Loadable(lazy(() => import('../pages/invoice/InvoiceListPage')));
export const InvoiceDetailPage = Loadable(lazy(() => import('../pages/invoice/InvoiceDetailsPage')));
export const InvoiceNewPage = Loadable(lazy(() => import('../pages/invoice/InvoiceCreatePage')));
export const InvoiceEditPage = Loadable(lazy(() => import('../pages/invoice/InvoiceEditPage')));

export const ApiKeys = Loadable(lazy(() => import('../pages/apiKeys/ApiKeys')));
export const EncryptionKeys = Loadable(lazy(() => import('../pages/encryptionKeys/EncryptionKeys')));

export const ModelListing = Loadable(lazy(() => import('../pages/models/list/ModelListing')));
export const ModelCreatePage = Loadable(lazy(() => import('../pages/models/new/ModelCreatePage')));
export const ModelDetailsPage = Loadable(lazy(() => import('../pages/models/detail/ModelDetailsPage')));
export const ModelEditPage = Loadable(lazy(() => import('../pages/models/detail/ModelEditPage')));

export const PlanAdminListing = Loadable(lazy(() => import('../pages/plans/adminlist/PlanAdminListing')));
export const PlanClientListing = Loadable(lazy(() => import('../pages/plans/clientlist/PlanClientListing')));
export const PlanCreatePage = Loadable(lazy(() => import('../pages/plans/new/PlanCreatePage')));
export const PlanEditPage = Loadable(lazy(() => import('../pages/plans/edit/PlanEditPage')));

// v1 route this 
export const OrgSubsPage = Loadable(lazy(() => import('../pages-v1/plans/assignedPlans/OrgSubsPage')));

export const OrgSubsListing = Loadable(lazy(() => import('../pages/subscription/orgsubs/OrgSubsListing')));
export const MySubsListing = Loadable(lazy(() => import('../pages/subscription/mysubs/MySubsListing')));

export const FileUploads = Loadable(lazy(() => import('../pages/file-uploads/FileUploads')));
export const SuperAdminFileUploads = Loadable(lazy(() => import('../pages/super-admin-file-upload/super-admin-file-uploads')));

export const FolderUploads = Loadable(lazy(() => import('../pages/folder-uploads/FolderUploads')));

export const PublicPayment = Loadable(lazy(() => import('../pages/payment/PublicPaymentPage')));
export const Payment = Loadable(lazy(() => import('../pages/payment/Payment')));

export const TransactionListPage = Loadable(lazy(() => import('../pages/transaction/TransactionListPage')));
export const TransactionDetailPage = Loadable(lazy(() => import('../pages/transaction/TransactionDetailsPage')));
export const OrgAdminTransactionListPage = Loadable(lazy(() => import('../pages/org-transactions/org-admin-transaction-list-page')));
export const ModelTransactionListPage = Loadable(lazy(() => import('../pages/modelTransaction/ModelTransactionListPage')));
export const TransactionSyncListPage = Loadable(lazy(() => import('../pages/transactionSync/TransactionSyncListPage')))
export const CompressionListPage = Loadable(lazy(() => import('../pages/compression/CompressionListPage')));
export const AuditLogs = Loadable(lazy(() => import('../pages/auditLogs/AuditLogs')));

export const Threshold = Loadable(lazy(() => import('../pages/threshold/Threshold')));
export const CustomEmail = Loadable(lazy(() => import('../pages/custom-email/CustomEmail')));
export const DataTraining = Loadable(lazy(() => import('../pages/dataTraining/DataTraining')));

export const DocumentManagerPage = Loadable(lazy(() => import('../pages/document-manager/view/document-manager-page')));
export const DocumentManagerSharedPage = Loadable(lazy(() => import('../pages/document-manager/view/document-manager-shared-page')));
export const DocumentManagerBinPage = Loadable(lazy(() => import('../pages/document-manager/view/document-manager-bin-page')));

export const CustomTemplates = Loadable(lazy(() => import('../pages/custom-templates/CreateNewTemplate')));
export const CreateTemplateCategory = Loadable(lazy(() => import('../pages/custom-templates/NewCategoryForm')));
